/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Material Dashboard 2 PRO React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// Material Dashboard 2 PRO React Dark Mode themes
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Material Dashboard 2 PRO React routes
import routes from "routes";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import AdminRoutes from "routes/AdminRoutes.js";
import VendorRoutes from "routes/VendorRoutes.js";
import CategoryRoutes from "routes/CategoryRoutes.js";
import CollectionRoutes from "routes/CollectionRoutes.js";
import ProductRoutes from "routes/ProductRoutes.js";
import ServiceRoutes from "routes/ServiceRoutes.js"
import CustomFieldRoutes from "routes/CustomFieldRoutes.js";
import OrderRoutes from "routes/OrderRoutes.js";
import ReviewRoutes from "routes/ReviewRoutes.js";
import withdrawalRoutes from "routes/WithdrawalRoutes";
import RoleRoutes from "routes/RoleRoutes";
import SubadminRoutes from "routes/SubadminRoutes";
import CustomerRoutes from "routes/CustomerRoutes";
import ReturnRequestRoutes from "routes/ReturnRequstRoutes";
import RefundRoutes from "routes/RefundRoutes";
import TicketsRoutes from "routes/TicketsRoutes";
import SettingsRoutes from "routes/SettingsRoutes";

import  configurationContext  from "contextConfig";
import Config from "config";
import axios from "axios";
export default function App() {

  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);


    const BASE=Config.BASE;
    const [configurationData,setConfigurationData]=useState('');
    const getConfiguration=async()=>{


      await axios({
  
      // Endpoint to send files
      url: BASE+"api/configuration/frontendSettings",
      method: "GET",
      headers: {
        Authorization: `no token`
     }

    }).then(function (response) {
    
     
  
      if(response.status==200 && response.data.status==1)
      {
        setConfigurationData(response.data.data);
      }
     
  
    }).catch((err)=>{
      
      
  
    });



    }

   
    
    useEffect(() => {
      getConfiguration();
    }, []);
  


    
 

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );

  return direction === "rtl" && configurationData ? (
    
    <configurationContext.Provider value={configurationData}>
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
   
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="Multivendor App"
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
        
          </>
        )}
        {layout === "vr" && <Configurator />}
     
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/admin/login" />} />
        </Routes>
      </ThemeProvider>
    </CacheProvider>
    </configurationContext.Provider>
  ) : (configurationData)?(
    <configurationContext.Provider value={configurationData}>
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
      <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
           brandName="Multivendor App"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
       
        </>
      )}
      {layout === "vr" && <Configurator />}
      
      
      <Routes>
        {getRoutes(routes)}
        {getRoutes(AdminRoutes)}
        {getRoutes(VendorRoutes)}
        {getRoutes(CategoryRoutes)}
        {getRoutes(CollectionRoutes)}
        {getRoutes(ProductRoutes)}
        {getRoutes(ServiceRoutes)}
        {getRoutes(CustomFieldRoutes)}
        {getRoutes(OrderRoutes)}
        {getRoutes(ReviewRoutes)}
        {getRoutes(withdrawalRoutes)}
        {getRoutes(RoleRoutes)}
        {getRoutes(SubadminRoutes)}
        {getRoutes(CustomerRoutes)}
        {getRoutes(ReturnRequestRoutes)}
        {getRoutes(RefundRoutes)}
        {getRoutes(TicketsRoutes)}
        {getRoutes(SettingsRoutes)}
        
        
        
        <Route path="*" element={<Navigate to="/admin/login" />} />
    
      </Routes>
      
   

    </ThemeProvider>
    </configurationContext.Provider>
  ):null;
}
